import React from 'react';
import {
  MessageImage,
  RenderMessageImageProps,
} from 'react-native-gifted-chat';
import {View} from 'react-native';
import {ChatMessage} from '../../../types';

export function ChatBubbleImage(
  props: RenderMessageImageProps<ChatMessage>,
) {
  return (
    <View>
      <MessageImage {...props} imageProps={{...props.imageProps}} />
    </View>
  );
}
